import _ from 'lodash'
import Popper from 'popper.js'
import $ from 'jquery'
import 'bootstrap'
import './typeahead'
import axios from 'axios'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window._ = _
window.Popper = Popper
window.axios = axios

// CDN jQuery is loaded synchronously in layout heads (select2, datatables attach to it).
// Bootstrap plugins from npm attach to the npm $ instance. Copy them onto CDN jQuery
// so inline blade scripts can call .modal(), .tooltip(), etc. via window.$ (CDN jQuery).
// CDN plugins (select2, datatables) stay on CDN jQuery — window.$ is not overwritten.
const cdnJQuery = window.jQuery
if (cdnJQuery && cdnJQuery !== $) {
    ;['alert', 'button', 'carousel', 'collapse', 'dropdown', 'modal', 'popover', 'scrollspy', 'tab', 'toast', 'tooltip', 'typeahead'].forEach(function (plugin) {
        if ($.fn[plugin]) { cdnJQuery.fn[plugin] = $.fn[plugin] }
    })

    // Bootstrap triggers synthetic jQuery events via npm $. Inline blade scripts listen
    // via CDN jQuery (window.$). Bridge: re-trigger on CDN jQuery so those listeners fire.
    ;['show.bs.modal', 'shown.bs.modal', 'hide.bs.modal', 'hidden.bs.modal', 'hidePrevented.bs.modal',
      'show.bs.tab', 'shown.bs.tab', 'hide.bs.tab', 'hidden.bs.tab',
      'show.bs.collapse', 'shown.bs.collapse', 'hide.bs.collapse', 'hidden.bs.collapse',
      'typeahead:select', 'typeahead:selected', 'typeahead:autocompleted', 'typeahead:opened', 'typeahead:closed', 'typeahead:cursorchanged'].forEach(function (eventName) {
        $(document).on(eventName, function (e, suggestion, dataset) {
            cdnJQuery(e.target).trigger(e.type, [suggestion, dataset])
        })
    })
} else {
    window.$ = window.jQuery = $
}

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

window.Pusher = Pusher

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
})

window.Echo.connector.pusher.connection.bind('connected', () => {
    window.Livewire?.dispatch('websocket-reconnected')
})
